import GlobalHook from "use-global-hook";
import * as actions from "./actions";

const initialState = {

  dummy: 0,

  user_name: "",
  user_role: "",

  companiesList: [],

  user: {

    id: "",
    company_name: "",
    comment: "",
    fio: "",
    email: "",
    phone: "",
    created_at: "",
    active: 1,

  },

  subscribe: {
    dateStart: '',
    dateEnd: '',
    remainingDays: ''
  }

}

const useGlobal = GlobalHook( initialState, actions );

export default useGlobal;